module.exports = __webpack_public_path__ + "static/door-4f24da1f4738af3b72d19b0ab45b6c31.png";